module.exports = __webpack_public_path__ + "img/shield-app.656b175d.svg";